import '../../../../assets/css/subscreens/customer/home/platformvidoe/PlatformVidoe.css';
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Loader2, VideoOff } from 'lucide-react';
import AppContext from '../../../../context/AppContext';

const AdminVideoSection = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchVideo = async () => {
    try {
      setLoading(true);
      setError(false);

      const res = await axios.get(`${baseUrl}/hero/section`);

      const file = res.data?.video;

      if (file) {
        setVideoUrl(file);
      } else {
        setError(true);
      }
    } catch (err) {
      console.log(err.response?.data || err.message);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideo();
  }, []);

  return (
    <section className="avs-section">

      {loading ? (
        <div className="avs-state">
          <Loader2 size={30} className="avs-state__spin" />
          <p>Loading video...</p>
        </div>
      ) : error || !videoUrl ? (
        <div className="avs-state">
          <VideoOff size={30} />
          <p>No video has been added yet.</p>
        </div>
      ) : (
        <div className="avs-hero-video">

          <video
            className="avs-hero-video__video"
            src={videoUrl}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          />

          <div className="avs-hero-video__overlay"></div>

        </div>
      )}

    </section>
  );
};

export default AdminVideoSection;